import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class SvgIconsService {
  constructor(private http: HttpClient) {}

  loadSvgSprite(url: string): void {
    this.http.get(url, { responseType: 'text' }).subscribe((svgContent) => {
      const div = document.createElement('div');
      div.style.display = 'none';
      div.innerHTML = svgContent;
      document.body.insertBefore(div, document.body.firstChild);
    });
  }
}
